var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlovakiaLotoPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 135 135",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.354 48.328H12.757c-1.222 0-2.35.94-2.537 2.162L3.923 83.477c-.282 1.692.94 3.195 2.631 3.195h115.597c1.316 0 2.35-.94 2.631-2.162l6.297-33.081c.282-1.598-1.034-3.101-2.725-3.101z",
    fill: "#26247b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.218 55.282H46.872c-3.195 0-6.391 2.725-6.955 6.015l-2.35 12.218c-.658 3.383 1.41 6.109 4.699 6.109h13.345c3.195 0 6.391-2.725 6.955-6.015l2.35-12.218c.658-3.383-1.504-6.109-4.699-6.109zm-3.853 17.856H43.959l2.162-11.372h12.406l-2.162 11.372zm60.9-17.762H103.92c-3.195 0-6.391 2.725-6.955 6.015l-2.35 12.218c-.658 3.383 1.41 6.109 4.699 6.109h13.345c3.195 0 6.391-2.725 6.955-6.015l2.35-12.218c.564-3.383-1.504-6.109-4.699-6.109zm-3.947 17.856h-12.406l2.162-11.372h12.406l-2.162 11.372zm-80.072 3.101c-.376 1.786-2.068 3.289-3.759 3.289H18.02c-3.195 0-5.263-2.725-4.699-6.109l2.819-14.849c.376-1.786 2.068-3.289 3.759-3.289s2.819 1.504 2.537 3.289l-2.819 14.379h10.996c1.786 0 2.913 1.504 2.631 3.289zM94.427 58.76c-.376 1.786-2.068 3.289-3.759 3.289h-6.861L81.081 76.24c-.376 1.786-2.068 3.289-3.759 3.289s-2.819-1.504-2.537-3.289l2.725-14.191h-6.673c-1.692 0-2.819-1.504-2.537-3.289.376-1.786 2.068-3.289 3.759-3.289h19.736c1.88.094 3.007 1.504 2.631 3.289z",
    fill: "#ed1d24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-46 100zm-11-5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovakiaLotoPlus);
export default __webpack_public_path__ + "static/media/slovakia_loto_plus.c926657376d1e5978c682274653f5c35.svg";
export { ForwardRef as ReactComponent };